export default __webpack_public_path__ + "images/e17e9a130d0381f0fbff028b95e27f7d-emoji-good.svg";